import { Box, Container, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ProofButton } from '../../../ui/button/ProofButton';
import { useOptions } from '..';
import { useSelector } from 'react-redux';
import { getEnableDocUpload } from '../../../store/ui/selector';

export default function IncomeVerificationIntro() {
  const { t } = useTranslation();
  const { handleNext } = useOptions();
  const enableDocUpload = useSelector(getEnableDocUpload);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const unmute = () => {
      const v = videoRef.current;
      if (v && v.muted) {
        v.muted = false;
        v.play().catch(() => {});
      }
      window.removeEventListener('pointerdown', unmute);
      window.removeEventListener('keydown', unmute);
    };
    window.addEventListener('pointerdown', unmute);
    window.addEventListener('keydown', unmute);
    return () => {
      window.removeEventListener('pointerdown', unmute);
      window.removeEventListener('keydown', unmute);
    };
  }, []);

  return (
    <>
      <Container maxWidth="xs" sx={{ px: 3 }}>
        <Typography variant="h2" sx={{ fontWeight: 500, mb: { xs: 1.5, md: 2.5 } }}>
          {t('verification.intro.title')}
        </Typography>
        <Typography variant="body1" sx={{ mb: { xs: 4, md: 3.5 } }}>
          {t('verification.intro.desc')}
        </Typography>
        <Box sx={{ py: 2, mb: 2 }}>
          <Box
            component="video"
            ref={videoRef}
            src="https://proofup-assets.s3.us-east-1.amazonaws.com/intro-video.mp4"
            autoPlay
            muted
            playsInline
            controls
            sx={{ width: '100%', display: 'block', borderRadius: 1 }}
          />
        </Box>
        <Stack flexDirection="row" gap={1.5} mb={3}>
          <Box component="img" src="/images/group2.svg" sx={{ width: '32px', height: '32px' }} />
          <Typography variant="body1">{t(enableDocUpload ? 'verification.intro.desc1' : 'verification.intro.desc1_no_upload')}</Typography>
        </Stack>
        <Stack flexDirection="row" gap={1.5} mb={4}>
          <Box component="img" src="/images/group1.svg" sx={{ width: '32px', height: '32px' }} />
          <Typography variant="body1">{t('verification.intro.desc2')}</Typography>
        </Stack>
        <Box sx={{ backgroundColor: 'primary.100', borderRadius: 1, p: 1, mb: 3 }}>
          <Stack flexDirection="row" gap={1.5} alignItems="center">
            <InfoOutlinedIcon />
            <Typography variant="body2">{t('verification.intro.information')}</Typography>
          </Stack>
        </Box>
        <ProofButton variant="contained" fullWidth onClick={handleNext}>
          {t('page.getStarted')}
        </ProofButton>
      </Container>
    </>
  );
}
